(function(e) {
	window.flitsObjects.allCssJs.socialLoginJs && e.LoadStyleScript("socialLoginJs", window.flitsObjects.allCssJs.socialLoginJs.url), e(document).on("Flits:Navigation:Loaded", function(i) {
		var o = i.detail.settings,
			t = {
				title: "Manage Subscriptions",
				//url: "/pages/manage-subscriptions",
                url: "/apps/retextion/login",
				target: 1,
				badge: null,
				icon: '<img src="https://img.icons8.com/fluency-systems-regular/48/000000/bookmark-ribbon--v1.png"/>',
				isShow: 1,
				loader: null,
				body_html: ""
			};
		o.navs.splice(2, 0, t)
	});

	function n() {
		var i = e(".flits-custom-lion-page").children().children(),
			o = e(".flits-custom-lion-page-mobile").children().children();
		e("#flits_tab_rewards").prepend(i), e("#flits_mobile_tab_rewards").prepend(o), e(".flits-custom-lion-page").remove(), e(".flits-custom-lion-page-mobile").remove()
	}
	e(document).on("Flits:AccountPage:Loaded", function(i) {
		setTimeout(function() {
			n()
		}, 2e3)
	})
})(Flits);
//# sourceMappingURL=/s/files/1/2251/0437/t/126/assets/flits_custom.js.map?v=1654149391